import {
  type Action,
  type GameState,
  type Player,
  applyAction,
  getPawnMoves,
  listLegalWalls,
  otherPlayer,
  shortestPathLength,
} from "./engine";

/**
 * 1수 그리디 AI: 후보 액션(이동 전체 + 합법 벽 전체)을 각각 적용해봤을 때
 * "상대 최단거리 - 내 최단거리"가 가장 커지는 수를 선택한다.
 * 즉시 이길 수 있는 이동은 무조건 선택한다.
 */
export function chooseAiAction(state: GameState, player: Player): Action {
  const opponent = otherPlayer(player);

  const moveActions: Action[] = getPawnMoves(state, player).map((to) => ({
    type: "move",
    to,
  }));
  const wallActions: Action[] = listLegalWalls(state, player).map((w) => ({
    type: "wall",
    orientation: w.orientation,
    r: w.r,
    c: w.c,
  }));

  const candidates = [...moveActions, ...wallActions];
  if (candidates.length === 0) {
    throw new Error("Quoridor: 둘 수 있는 수가 없습니다 (규칙상 발생하지 않아야 함)");
  }

  let best = candidates[0];
  let bestScore = -Infinity;

  for (const action of candidates) {
    const next = applyAction(state, action);
    let score: number;
    if (next.winner === player) {
      score = Number.POSITIVE_INFINITY;
    } else {
      const myPath = shortestPathLength(next, player);
      const oppPath = shortestPathLength(next, opponent);
      score = oppPath - myPath;
      // 벽 사용은 동점일 때 이동보다 약간 불리하게 둬서 불필요한 소모를 줄인다.
      if (action.type === "wall") score -= 0.5;
    }
    if (score > bestScore) {
      bestScore = score;
      best = action;
    }
  }

  return best;
}
